<template>
    <div ref="productModal" class="modal fade" :id="dialogId" role="dialog" :aria-labelledby="dialogId"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-popout" role="document">
            <div class="modal-content">
                <div class="block block-themed block-transparent mb-0">
                    <div class="block-header bg-primary-dark">
                        <h3 class="block-title">{{title}}</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="block-content">
                        <form>
                            <div class="form-group">
                                <label>Name</label>
                                <input :class="{'is-invalid': errors.name}" v-model="product.name" type="text"
                                       class="form-control">
                                <div v-if="errors.name" :class="['invalid-feedback']">
                                    {{errors.name[0]}}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5 form-group">
                                    <label for="product-icon">Icon <small class="small">(Material Icons)</small></label>
                                    <input id="product-icon" :class="{'is-invalid': errors.meta && errors.meta.icon}"
                                           v-model="product.meta.icon" type="text" class="form-control"/>
                                    <div v-if="errors.meta && errors.meta.icon" :class="['invalid-feedback']">
                                        {{errors.meta.icon[0]}}
                                    </div>
                                </div>
                                <div class="col-md-7 form-group">
                                    <label for="product-color-input">BG Color</label>
                                    <div ref="product-color" class="input-group">
                                        <input ref="product-color-input" id="product-color-input"
                                               :class="{'is-invalid': errors.meta && errors.meta.color}"
                                               v-model="product.meta.color" type="text" class="form-control"/>
                                        <span class="input-group-append">
                                        <span class="input-group-text colorpicker-input-addon"><i></i></span>
                                    </span>
                                    </div>
                                    <div v-if="errors.meta && errors.meta.color" :class="['invalid-feedback']">
                                        {{errors.meta.color[0]}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Access Level</label>
                                <select :class="{'is-invalid': errors.access}" v-model="product.access"
                                        class="form-control">
                                    <option :value="level.toLowerCase()" v-for="(level, key) in accessLevels"
                                            :key="key">{{level}}
                                    </option>
                                </select>
                                <div v-if="errors.access" :class="['invalid-feedback']">
                                    {{errors.access[0]}}
                                </div>
                            </div>
                            <div class="form-group text-center align-content-center">
                                <div class="custom-control custom-control-inline custom-checkbox custom-control-primary mb-1">
                                    <input name="environment[]" v-model="product.environment" value="sandbox"
                                           type="checkbox" class="custom-control-input" id="sandbox">
                                    <label class="custom-control-label" for="sandbox">Sandbox</label>
                                </div>
                                <div class="custom-control custom-control-inline custom-checkbox custom-control-primary mb-1">
                                    <input name="environment[]" v-model="product.environment" value="production"
                                           type="checkbox" class="custom-control-input" id="production">
                                    <label class="custom-control-label" for="production">Production</label>
                                </div>
                                <div v-if="errors['environment']" class="text-danger">{{errors['environment'][0]}}</div>
                            </div>
                            <div class="form-group">
                                <label for="description">Description</label>
                                <textarea id="description" :class="{'is-invalid': errors.description}"
                                          v-model="product.description" rows="3" class="form-control"></textarea>
                                <div v-if="errors.description" :class="['invalid-feedback']">
                                    {{errors.description[0]}}
                                </div>
                            </div>
                        </form>
                    </div>
                    <slot name="submit"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import $ from 'jquery';

    export default {
        props: {
            dialogId: String,
            title: String,
            product: Object
        },
        name: "ProductForm",
        data() {
            return {
                accessLevels: [
                    'Private', 'Internal', 'Public'
                ],
            }
        },
        watch: {

        },
        mounted() {
            $(this.$refs.productModal).on('hidden.bs.modal', () => {
                this.$store.commit('setCreatingApiProduct', false);
                this.$store.commit('setUpdatingApiProduct', false);
                this.$store.commit('setApiProductErrors', {});
            });
            $(this.$refs['product-color']).colorpicker({
                color: this.product.meta.color,
                format: "rgb"
            }).on('colorpickerChange', e => {
                this.product.meta.color = e.color.string()
            })
        },
        computed: {
            ...mapGetters({
                status: 'getProductCreatedStatus',
                errors: 'getApiProductErrors',
            })
        },
    }
</script>
